import styled from 'styled-components';
import { layout, media, remCalc } from 'src/components/base';
import { Link } from 'react-router-dom';
import { Button } from '@prisjakt/ui/button';
import { Row } from '@prisjakt/ui/list/variants';
import BaseFilter from './components/filter';
import { PageHeader } from 'src/components/page';
import { zindex } from 'src/ui/zindex';

const buttonHeight = '40px';

export const CategoryPageGutter = styled.div`
  padding-left: ${layout.measurements.spacing050};
  padding-right: ${layout.measurements.spacing050};
`;

export const CategoryPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  max-width: 1000px;
`;

export const CategoryPageHeader = styled(PageHeader)`
  flex: 1;
  flex-basis: 60%;
`;

export const CategoryPageHeaderMedia = styled.img`
  ${media.smallOnly`
    display: none;
  `}
`;

export const CategoryPageHeaderDescription = styled.div`
  max-width: 500px;
  color: ${({ theme }) => theme.text.secondary};

  ul {
    margin-left: 15px;
    color: ${({ theme }) => theme.text.secondary};

    &::after {
      content: '';
      clear: both;
      display: table;
    }
  }
`;

export const CategoryPageHeaderAliases = styled.div`
  margin-top: ${layout.measurements.spacing100};
`;

export const CategoryPageSubHeader = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
`;

export const CategoryPageProductWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${media.mediumUp`
    border-top: 1px solid ${({ theme }) => theme.lines.secondary};
    padding-top: ${layout.measurements.spacing100};
  `}
`;

export const CategoryPageProducts = styled.div`
  min-width: 0;
  flex: 1 1 0;
`;

export const CategoryPageAdWrapper = styled.div`
  width: 100%;
`;

export const Filter = styled(BaseFilter)<{ open?: boolean }>`
  min-width: 0;
  flex: 1 1 0;

  ${media.largeUp`
    max-width: 220px;
    padding-right: ${remCalc(11)};

    @supports (position: sticky) {
      position: sticky;
      top: ${layout.headerHeight.desktop.rem};
      overflow-x: hidden;
      overflow-y: auto;
      max-height: calc(100vh - ${layout.headerHeight.desktop.rem});
      margin-bottom: 10px;
      margin-right: ${layout.pageContent.gutter.rem};
      scroll-behavior: smooth;
      z-index: 5;
    }
  `};

  ${media.mediumDown<{ open?: boolean }>`
    display: ${props => (props.open ? 'block' : 'none')};
    background: ${p => p.theme.bg.primary};
    position: fixed;
    padding-right: ${layout.pageContent.gutter.rem};
    padding-left: ${layout.pageContent.gutter.rem};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${zindex.menu.filter};
    overflow: auto;
    overflow-y: scroll; /* has to be scroll, not auto */
    -webkit-overflow-scrolling: touch;
  `};
`;

export const BrandLink = styled(Link)`
  margin-right: ${layout.measurements.spacing100};
`;

export const BrandLogo = styled.img`
  width: 88px;
  height: 31px;
`;

export const PanelHeaderActions = styled(Row)`
  && {
    flex: 0 1 auto;
  }
`;

export const PanelHeaderButtons = styled(Row)`
  align-items: center;
`;

export const PanelHeader = styled(Row)`
  align-items: center;
`;

export const FilterButton = styled(Button)`
  max-height: ${buttonHeight};
  margin-right: ${layout.measurements.spacing050};

  ${media.mediumDown`
    display: none;
  `};
`;

export const Column = styled.div<{ fullWidth?: boolean }>`
  padding-right: 0.8rem;
  padding-left: 0.8rem;
  min-width: 0;

  flex: 0 0 ${p => (p.fullWidth ? '100%' : '50%')};
  max-width: ${p => (p.fullWidth ? '100%' : '50%')};
`;

export const BreadCrumWrapper = styled.div`
  margin: ${layout.measurements.spacing050} ${layout.measurements.spacing050}
    ${layout.measurements.spacing050} 0;
`;
